import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { selectors as globalSelectors } from 'global-reducer'
import { selectors as globalSchoolSelectors } from 'school-portal-reducer'
import { Spinner } from 'lp-components'
import { SectionBlock, PortalHeader, ProfileCompletionBar } from 'components'
import { SCHOOL_PORTAL_ROUTE } from 'config'
import { useCommunity } from 'utils'
import {
  buildBarModel,
  buildInterestCompletionOptions,
} from './profile-completion-sections'

const propTypes = {
  children: PropTypes.node,
  school: Types.school,
  completionSchool: Types.school,
  detail: Types.detail,
  currentSchoolYear: Types.schoolYear.isRequired,
  interestCompletionOptions: PropTypes.object,
}

const defaultProps = {
  children: null,
  school: null,
  completionSchool: null,
  detail: null,
  interestCompletionOptions: {},
}

function Layout({
  children,
  school,
  completionSchool,
  detail,
  currentSchoolYear,
  interestCompletionOptions,
}) {
  const {
    defaultBranding: { dashboardHeader },
    schoolProfileCompletionEnabled,
  } = useCommunity()

  const hasLoaded = !!(school && detail)
  // Completion is always evaluated against the current-school-year school so it
  // stays stable when the global school is loaded for a different (survey) year.
  const completionSchoolForBar = completionSchool || school
  const showBar = schoolProfileCompletionEnabled && completionSchoolForBar
  const barModel = showBar
    ? buildBarModel(completionSchoolForBar, interestCompletionOptions)
    : null
  return (
    <div>
      <PortalHeader
        title={`${currentSchoolYear.number} artlook Map Profile`}
        backgroundImage={dashboardHeader}
        links={[
          {
            name: 'Overview',
            path: SCHOOL_PORTAL_ROUTE + '/summary/overview',
          },
          {
            name: 'School Partnerships & Interests',
            path: SCHOOL_PORTAL_ROUTE + '/summary/partnerships-with-interests',
          },
        ]}
      />
      <div className="content-block-container">
        {showBar && (
          <SectionBlock>
            <ProfileCompletionBar
              variant="tab-header"
              percent={barModel.percent}
              completedSections={barModel.completedSections}
              sections={barModel.sections}
            />
          </SectionBlock>
        )}
        {!hasLoaded ? <Spinner /> : <React.Fragment>{children}</React.Fragment>}
      </div>
    </div>
  )
}

Layout.propTypes = propTypes
Layout.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    detail: globalSchoolSelectors.currentDetail(state),
    school: globalSchoolSelectors.school(state),
    completionSchool: globalSchoolSelectors.completionSchool(state),
    currentSchoolYear: globalSelectors.currentSchoolYear(state),
    interestCompletionOptions: buildInterestCompletionOptions(state),
  }
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Layout)
